import styled from "@emotion/native"
import { Text, TextTypes } from "./Typography"

type AvatarProps = {
  color?: string
  initials?: string
  size?: number
  textType?: TextTypes
}

export function Avatar(props: AvatarProps) {
  const { initials, color, size, textType } = props

  return (
    <AvatarContainer>
      <AvatarInitials backgroundColor={color} size={size}>
        <Text color="quaternary" type={textType}>
          {initials}
        </Text>
      </AvatarInitials>
    </AvatarContainer>
  )
}

const AvatarContainer = styled.View``

const AvatarInitials = styled.View<{
  backgroundColor: string | undefined
  size: number | undefined
}>`
  background-color: ${({ theme, backgroundColor }) => backgroundColor ?? theme.text.tertiary};
  border-radius: 100px;
  width: ${({ size }) => (size ? `${size}px` : "45px")};
  height: ${({ size }) => (size ? `${size}px` : "45px")};
  justify-content: center;
  align-items: center;
`
